module.exports = __webpack_public_path__ + "pe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pe.svg
// module id = 749
// module chunks = 0